// extracted by mini-css-extract-plugin
export default {"nav":"NavBar_nav_zIdBd","nav-link":"NavBar_nav-link_jFkgc","profile":"NavBar_profile_h4GSL"};